export default "__VITE_ASSET__Dw6nix4W__"